import { HEX } from "../../../src/actions/hex-patterns";
import { Targeting } from "../../../src/actions/targeting";
import { SEC } from "../../../src/time-utils";
const nature_sight = {
  slug: "nature_sight",
  name: "Tree Sight",
  description: "Perceive hidden foes through the eyes of nature",
  abilityIcon: "nature_sight",
  costs: [
    { stat: "mana", value: 12 }
  ],
  targeting: Targeting.Self,
  cooldown: SEC(10),
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {}
            }
          ],
          addConditions: [
            {
              slug: "nature_sight",
              name: "Nature Sight",
              tags: ["buff"]
            }
          ],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "buff", "green"]
};
export {
  nature_sight
};
//# sourceMappingURL=data:application/json;base64,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
